'use es6';

import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
const DowngradeAlert = ({
  downgradeMessageKey,
  options
}) => {
  return /*#__PURE__*/_jsx(Alert, {
    alignItems: "center",
    type: "danger",
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `downgradeAlerts.${downgradeMessageKey}.title`,
      options: options
    }),
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `downgradeAlerts.${downgradeMessageKey}.body`,
      options: options
    })
  });
};
export default DowngradeAlert;